import { createFileRoute } from "@tanstack/react-router";
import InvoiceRequests from "@/components/InvoiceRequests";

function RouteComponent() {
  return <InvoiceRequests />;
}

export const Route = createFileRoute("/_authenticated/invoice-requests/")({
  component: RouteComponent,
  staticData: { page: ["finance", "deals", "distributions"] },
});
